import {
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core'
import { ControlContainer, NgForm } from '@angular/forms'
import { Listbox } from 'primeng/listbox'

@Component({
  selector: 'op-listbox-ng',
  templateUrl: './listbox.component.html',
  styleUrls: ['./listbox.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm,
    },
  ],
})
export class ListboxNgComponent<
  TOption extends object = object,
  TValue = unknown,
> {
  @ViewChild('listbox', { static: false }) listbox?: Listbox

  @Input() placeholder?: string
  @Input() class?: string
  @Input() key?: string
  @Input() values?: TValue | TValue[]
  @Input() dataSource?: TOption[]
  @Input() maxHeight = '250px'

  // Templates
  @Input() itemTemplate?: TemplateRef<{ $implicit: TOption }>

  // Search params
  @Input() optionValue = '_id'
  @Input() optionLabel = 'name'
  @Input() filterBy?: string

  // Style
  @Input() filter = false
  @Input() multiple = false
  @Input() disabled = false
  @Input() showClear = true
  @Input() metaKeySelection = true

  @Output() readonly valuesChange = new EventEmitter<TValue | TValue[] | null>()

  get options(): TOption[] {
    return this.dataSource || []
  }

  onValueChange(value: TValue | TValue[] | null): void {
    this.values = this.checkValue(value)
    this.valuesChange.emit(this.values)
  }

  checkValue(value: TValue | TValue[] | null): TValue | TValue[] | undefined {
    if (value === null) {
      return this.multiple ? [] : undefined
    }
    return value
  }
}
